export default __webpack_public_path__ + "static/media/onTheWayRT.2b2300c8.webp";